import api from "../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    Ages: [],
  },
  getters: {
    getAges(state) {
      return state.Ages;
    },
  },
  mutations: {
    SetAges(state, data) {
      state.Ages = [];
      state.Ages = data;
    },
  },
  actions: {
    getAges({ commit }) {
      return new Promise((resolve, rej) => {
      api()
        .post(
          `Ages/getAges`,
          {},
          {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
        )
        .then((res) => {
          resolve(res);
          commit("SetAges", res.data);
        })
        .catch((err) => console.log(err));});
    },
    

    addAge({  }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Ages/addAgeToUser`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
   
  },
};
